import React from "react";
type Prediction = { prediction: string };

interface ResultComponentProps {
    prediction: Prediction;
}

const Result = ({ prediction }: ResultComponentProps) => {
    return (
        <div className={"text-2xl text-center"}>
            Prediction: {prediction.prediction }
        </div>
    );
};

export default Result;